/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Prep_Regenerate_SaveInputs */



/**
* | output |
* | --- |
* | "Yes, make it again" |
*
* @param {Meeting_Prep_Regenerate_SaveInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_prep_regenerate_save = /** @type {((inputs?: Meeting_Prep_Regenerate_SaveInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Prep_Regenerate_SaveInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Ja, opnieuw maken")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Oui, refaire")
	return /** @type {LocalizedString} */ ("Yes, make it again")
});